(() => {
  'use strict';
  const root = document.querySelector('[data-mw-product]');
  const panel = root?.querySelector('[data-restock]');
  if (!panel) return;
  const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const sizeForm = document.getElementById('mw-product-form');
  const form = panel.querySelector('[data-restock-form]');
  const button = form.querySelector('[data-restock-submit]');
  const status = form.querySelector('[data-restock-status]');
  const related = form.querySelector('[data-restock-related]');
  const mapper = window.MidwoodSizeMapper;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const current = () => product.variants.find(v => String(v.id) === sizeForm.querySelector('[name=id]:checked')?.value);
  const mapping = (p,v) => {
    const i = p.optionNames.findIndex(n => mapper?.sizeOptionName(n));
    return i < 0 ? null : mapper.mapOption(v.options[i],p);
  };
  const label = (p,v) => p.optionNames.length === 1 ? mapping(p,v)?.storefront_label || v.options.join(' / ') : v.options.join(' / ');
  const link = (p,v) => `${p.url}?variant=${v.id}`;
  const model = p => p.displayTitle.split('/')[0].trim().toLowerCase();
  let catalogPromise, generation = 0, choices = [], busy = false;
  const completed = new Set(); // Memory only: no email addresses in browser storage.
  async function json(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {...options, signal:controller.signal});
      if (!response.ok) throw new Error('Request failed');
      return response.status === 202 || response.status === 204 ? null : await response.json();
    } finally { clearTimeout(timer); }
  }
  async function catalog() {
    if (!catalogPromise) catalogPromise = (async () => {
      const all = [];
      // Brand collections keep this bounded. Four pages cover up to 1,000 styles.
      for (let page = 1, pages = 1; page <= Math.min(pages,4); page++) {
        const url = new URL(panel.dataset.collection,location.origin);
        url.searchParams.set('view','mw-watch-data');url.searchParams.set('page',page);
        const data = await json(url);
        if (!Array.isArray(data.products)) throw new Error('Invalid catalog');
        all.push(...data.products);pages = Number(data.pages) || 1;
      }
      return all;
    })().catch(error => {catalogPromise = null;throw error;});
    return catalogPromise;
  }
  function sameSize(a,b) {
    if (!a || !b) return false;
    // Do not infer cross-brand fit or convert EU sizing to US.
    return a.hits?.some(x => b.hits?.some(y => x.gender === y.gender && String(x.size) === String(y.size) && x.locale === y.locale && (x.width || '') === (y.width || '')));
  }
  async function renderRelated(v) {
    const run = ++generation;choices = [];
    related.innerHTML = '<p>Finding related pairs in this size…</p>';
    const target = mapping(product,v);
    if (!target || product.optionNames.length !== 1) {related.replaceChildren();return;}
    try {
      const products = await catalog();
      if (run !== generation) return;
      const candidates = products.filter(p => p.id !== product.id && p.vendor === product.vendor && p.optionNames.length === 1)
        .map(p => ({p,v:p.variants.find(x => sameSize(target,mapping(p,x))),score:model(p) === model(product) ? 2 : p.type === product.type ? 1 : 0}))
        .filter(x => x.v && x.score > 0).sort((a,b) => b.score-a.score || Number(a.v.available)-Number(b.v.available));
      choices = candidates.slice(0,3);
      if (!choices.length) {related.innerHTML = '<p>No close matches in this size right now. You can still request an alert for this pair.</p>';return;}
      related.innerHTML = '<h3>Keep your options open</h3><p>More from '+esc(product.vendor)+', in this size. Select any sold-out pairs you’d also like to hear about.</p>' + choices.map(({p,v}) => {
        const detail = `<img src="${esc(p.image)}" alt="" width="80" height="66" loading="lazy"><span><strong>${esc(p.displayTitle)}</strong><small>${esc(label(p,v))} · ${v.available ? 'In stock — shop this pair' : 'Sold out — email me if it returns'}</small></span>`;
        return v.available ? `<a class="mw-watch-pair" href="${esc(link(p,v))}">${detail}</a>` : `<label class="mw-watch-pair">${detail}<input type="checkbox" name="alternative" value="${v.id}" aria-label="Also notify me: ${esc(p.displayTitle)}, ${esc(label(p,v))}"></label>`;
      }).join('');
    } catch {
      if (run === generation) related.innerHTML = '<p>Related pairs couldn’t load. Your alert for this shoe is still available.</p><button type="button" class="mw-text-link" data-retry-related>Try related pairs again</button>';
    }
  }
  related.addEventListener('click',e => {if (e.target.closest('[data-retry-related]') && current()) renderRelated(current());});
  function sync() {
    const v = current();
    panel.hidden = !v || v.available;
    root.querySelector('[data-add]').hidden = !!v && !v.available;
    status.replaceChildren();
    if (!panel.hidden) {
      panel.querySelector('[data-restock-selection]').textContent = `${product.displayTitle} · ${label(product,v)} — sold out`;
      renderRelated(v);
    } else {generation++;choices = [];}
  }
  // Keep unavailable choices disabled without JavaScript; enable only with the alert flow loaded.
  sizeForm.querySelectorAll('.mw-variant[data-available="false"] input').forEach(input => {input.disabled = false;});
  root.querySelector('[data-restock-hint]').hidden = !product.variants.some(v => !v.available);
  sizeForm.addEventListener('change',sync);
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (busy || !form.reportValidity()) return;
    const exact = current();if (!exact || exact.available) return;
    const email = form.elements.email.value.trim();
    const picked = new Set(Array.from(form.querySelectorAll('[name=alternative]:checked'),input => input.value));
    const requests = [{p:product,v:exact},...choices.filter(x => !x.v.available && picked.has(String(x.v.id)))];
    busy = true;generation++;button.disabled = true;button.textContent = 'Saving your alerts…';
    const locks = [...sizeForm.querySelectorAll('[name=id]'),...form.querySelectorAll('input')];
    locks.forEach(input => {input.disabled = true;});status.textContent = 'Checking these sizes and saving your requests…';
    const saved = [], failed = [], available = [];
    try {
      for (const item of requests) {
        const key = `${email.toLowerCase()}:${item.v.id}`;
        if (completed.has(key)) {saved.push(item);continue;}
        try {
          const fresh = await json(`${item.p.url}.js`);
          const variant = fresh.variants.find(v => String(v.id) === String(item.v.id));
          if (!variant) throw new Error('Variant removed');
          if (variant.available) {available.push(item);continue;}
          await json('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Ryg7fj', {
            method:'POST',headers:{'Content-Type':'application/json','revision':'2025-07-15'},
            body:JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:`$shopify:::$default:::${item.v.id}`}}}}})
          });
          completed.add(key);saved.push(item);
        } catch {failed.push(item);}
      }
      status.replaceChildren();
      const lines = [];
      if (saved.length) lines.push(`Alert${saved.length === 1 ? '' : 's'} saved for ${saved.map(x => `${x.p.displayTitle} (${label(x.p,x.v)})`).join('; ')}. We’ll email ${email} if your selected size returns.`);
      if (failed.length) lines.push(`Couldn’t save ${failed.map(x => `${x.p.displayTitle} (${label(x.p,x.v)})`).join('; ')}. Please try again. Saved alerts won’t be duplicated.`);
      if (available.length) lines.push('Good news: the following size is available now. Shop the pair below.');
      status.append(document.createTextNode(lines.join(' ')));
      available.forEach(({p,v}) => {const a=document.createElement('a');a.href=link(p,v);a.textContent=`Shop ${p.displayTitle} · ${label(p,v)}`;status.append(a);});
    } finally {
      busy = false;locks.forEach(input => {input.disabled = false;});button.disabled = false;
      button.textContent = failed.length ? 'Retry unsaved alerts' : 'Email me when in stock';
    }
  });
  sync();
})();
